import { useTranslation } from 'react-i18next'
import { Typography } from 'antd'
import { Page } from '../structure'

const { Title } = Typography

const Welcome = () => {
  const { t } = useTranslation()

  return (
    <Page className="welcome" title="Welcome">
      <Title>{t('Welcome.Welcome')}</Title>
    </Page>
  )
}
export default Welcome
